<template>
  <v-dialog v-model="dialogStatus"
            persistent
            max-width="800px">
    <div class="fill-height">


      <v-card class="fill-height">

        <v-card-subtitle>بررسی درخواست </v-card-subtitle>
        <v-spacer/>

        <v-card-text>


          <v-form  ref="form"  lazy-validation v-model="valid">
            <div v-if="showDialogMsg">
              <message :model-items="modelItem" :unit-list="unitList" :dialogStatus.sync="showDialogMsg"/>
            </div>
            <v-row>
              <v-col cols="12" md="3">
                <label> نام مجتمع:{{model.unit.building.name}}</label>
              </v-col>
              <v-col cols="12" md="3">
                <label> نام واحد:{{model.unit.unitName}}</label>
              </v-col>
              <v-col cols="12" md="3">
                <label> نام کاربر:{{model.user.person.fullName}}</label>
              </v-col>
              <v-col cols="12" md="3">
                <label> موبایل:{{model.user.userName}}</label>
              </v-col>
              <v-col cols="12"
                     md="12">

               <span style="float: right" class="my-2">
                <span class=" black--text"> متن درخواست:</span>
                 <strong >
                   {{model.text}}
                 </strong>

               </span>
              </v-col>

            </v-row>
            <v-divider class="p-1 m-1"/>
            <span style="float: right"><strong class="text-h6 black--text">پاسخ ها:</strong></span>
            <v-row class="mx-2">
              <v-col md="12">
               <div id="style-1" style="height:300px;overflow-y: auto" >
                 <v-timeline
                     :reverse="true"
                     dense >
                   <v-timeline-item
                       v-for="msg in messages_"
                       :key="msg.id"
                       color="grey"
                       icon-color="grey lighten-2"
                       small>

                     <v-row justify="space-between">

                       <v-col cols="7">
                         {{msg.text}}
                       </v-col>
                       <v-col
                           class="text-right"
                           cols="5"
                       >
                         {{msg.dateText}}
                       </v-col>
                     </v-row>

                   </v-timeline-item>
                 </v-timeline>
               </div>

              </v-col>

            </v-row>

            <v-divider class="p-1 m-1"/>
            <v-card-actions dir="ltr">

              <v-btn
                  small
                  depressed
                  color="error"
                  class=" pr-4 pl-4 m-1"
                  @click="closed"
              >
               بستن
              </v-btn>
              <v-btn depressed class=" pr-8 pl-8 m-1" v-if="can('editRequestUser')" small color="accent"
                     @click="forResponse(model)">
                پاسخ
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>

import Request_se from "@/views/define/requestUser/Request_se";
import Message from "@/views/define/message/PageEdit.vue";
import Message_se from "@/views/define/message/Message_se";

export default {
  components: {Message},

  props: {
    dialogStatus: {
      default: false,
    },
    model: Object,
    messages: Array,
    buildingId: String,
  },
  data() {
    return {
      valid: true,
      showDialogMsg: false,
      modelItem: {},
      unitList: [],
      messages_: this.messages,
    }
  },

  mounted() {
    this.$root.$on('UpdateMessage', () => {
      this.view()
    })

  },
  methods: {
    closed() {
      this.$root.$emit('RequestUser')
      this.$emit('update:dialogStatus', false)
    },
    view() {
      Request_se.view(this.model.id).then(response => {
        this.messages_ = response.data.messages
      })
    },
    forResponse: function (e) {

      Request_se.response(e.unit.id, e.user.id, e.id).then(response => {
        this.modelItem = response.data;
        this.buildingId = response.data.buildingId;
        this.getUserList(this.buildingId)
        this.showDialogMsg = true
      })
    },
    getUserList(val) {
      Message_se.getUser(val).then(response => {
        return this.unitList = response.data;
      })
    },
  },



}
</script>


